import Siema from 'siema/dist/siema.min.js';
import 'jquery';

import '../utils/slick.js';
var ev1 = document.createElement('script');
ev1.src = '//fast.wistia.com/assets/external/E-v1.js';
ev1.async = true;
ev1.charset = 'ISO-8859-1';
document.head.appendChild(ev1);

document.addEventListener('DOMContentLoaded', function (e) {});

function logo_2_box_gallery() {
  var width_window = window.innerWidth;
  if (width_window < 991) {
    if (!jQuery('.gallery-logo_1').hasClass('slick-initialized')) {
      jQuery('.gallery-logo_1').slick({
        dots: false,
        infinite: true,
        speed: 200,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        prevArrow: "<div class='arrow_data_our_cutomer arrow-left'> </div>",
        nextArrow: "<div class='arrow_data_our_cutomer arrow-right'> </div>"
      });
      jQuery('.gallery-logo_1').slick('refresh');
    } else {
      jQuery('.gallery-logo_1').slick('refresh');
    }
  } else {
    if (jQuery('.gallery-logo_1').hasClass('slick-initialized')) {
      jQuery('.gallery-logo_1').slick('unslick');
    }
  }
}
logo_2_box_gallery();
jQuery(window).resize(function () {
  logo_2_box_gallery();
});

function row_spt_box_gallery() {
  var width_window = window.innerWidth;
  if (width_window < 991) {
    if (!jQuery('.row-spt').hasClass('slick-initialized')) {
      jQuery('.row-spt').slick({
        dots: false,
        infinite: true,
        speed: 200,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        prevArrow: "<div class='arrow_data_our_cutomer arrow-left'> </div>",
        nextArrow: "<div class='arrow_data_our_cutomer arrow-right'> </div>"
      });
      jQuery('.row-spt').slick('refresh');
    } else {
      jQuery('.row-spt').slick('refresh');
    }
  } else {
    if (jQuery('.row-spt').hasClass('slick-initialized')) {
      jQuery('.row-spt').slick('unslick');
    }
  }
}
row_spt_box_gallery();
jQuery(window).resize(function () {
  row_spt_box_gallery();
});

function row_spt_box_2() {
  var width_window = window.innerWidth;
  if (width_window < 991) {
    if (!jQuery('.slider-box-2').hasClass('slick-initialized')) {
      jQuery('.slider-box-2').slick({
        dots: false,
        infinite: true,
        speed: 200,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        prevArrow: "<div class='arrow_data_our_cutomer arrow-left'> </div>",
        nextArrow: "<div class='arrow_data_our_cutomer arrow-right'> </div>"
      });
      jQuery('.slider-box-2').slick('refresh');
    } else {
      jQuery('.slider-box-2').slick('refresh');
    }
  } else {
    if (jQuery('.slider-box-2').hasClass('slick-initialized')) {
      jQuery('.slider-box-2').slick('unslick');
    }
  }
}
row_spt_box_2();
jQuery(window).resize(function () {
  row_spt_box_2();
});

jQuery(window).on('scroll', function () {
  if (!jQuery('.item_logo img').hasClass('sal-animate')) {
    setTimeout(function () {
      logo_2_box_gallery();
    }, 100);
  }
  if (!jQuery('.inner-agence-12').hasClass('sal-animate')) {
    setTimeout(function () {
      row_spt_box_gallery();
    }, 100);
  }
  if (!jQuery('.item_ct').hasClass('sal-animate')) {
    setTimeout(function () {
      row_spt_box_2();
    }, 100);
  }
});

setTimeout(function () {
  var width_window = window.innerWidth;
  if (width_window < 991) {
    var video_url = jQuery('#hero-bg-video').attr('poster-load');
    jQuery('#hero-bg-video').attr('poster', video_url);
  }
}, 3000);

/* document.querySelector('#hero-bg-video').setAttribute('poster-load', 'newvalue') */
